"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostgresParameterCapitalProviderSlugsConfigs = void 0;
const validatePostgresParameterCapitalProviderSlugsConfigs = (params) => {
    const { capitalProviderSlugs, configs } = params;
    const errors = [];
    configs.forEach((config) => {
        const { slugs } = config;
        slugs.forEach((slug) => {
            if (!capitalProviderSlugs.includes(slug)) {
                errors.push(`Postgres parameter capital provider slug config contains invalid capital provider slug: ${slug}. Valid slugs: ${JSON.stringify(capitalProviderSlugs)}`);
            }
        });
    });
    return { errors };
};
exports.validatePostgresParameterCapitalProviderSlugsConfigs = validatePostgresParameterCapitalProviderSlugsConfigs;
//# sourceMappingURL=postgresParameterCapitalProviderSlugsConfigs.js.map